import { render, staticRenderFns } from "./SetOfGifts.vue?vue&type=template&id=5baa338c&lang=pug"
import script from "./SetOfGifts.vue?vue&type=script&lang=js"
export * from "./SetOfGifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports